import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { ISiteNameSansId } from '../types/ISiteNameSansId';

export interface IGetSiteNamesAcrossAllPodsResult extends IGetItemsResult {
  siteNames: ISiteNameSansId[];
}

export class GetSiteNamesAcrossAllPodsRequest extends Request<IGetItemsParams, IGetSiteNamesAcrossAllPodsResult> {
  constructor(params: IGetItemsParams) {
    super('getSiteNamesAcrossAllPods', params);
  }
}
